import { FieldError, Label, RequiredMark, Wrapper } from './FloatingField.styles';
import type { FloatingFieldProps } from './FloatingField.types';

export function FloatingField({ label, hasValue, error, children }: FloatingFieldProps) {
  return (
    <Wrapper>
      {hasValue && (
        <Label>
          {label}
          <RequiredMark>*</RequiredMark>
        </Label>
      )}
      {children}
      {error && <FieldError>{error}</FieldError>}
    </Wrapper>
  );
}
